
<template>
    
    <div id="container">
        <div class="header">
             <div class="logo">
                <img style="width:auto;height:100%;margin: 10px auto;" src="~@/assets/logo.png"/>
             </div>
             <div class="header-center">
                <h1 class="welcome-title">新程悦居酒店后台管理系统</h1>
             </div>
             <div class="header-right">
                <div class="userbox">
                    <div class="userimg">
                        <img :src="userImg">
                    </div>
                    <div class="userbtn" ref="userbtn" @click="userbtnclick()">
                            <div class="username">
                                <span class="uname">{{ usershowname }}</span>
                                <i class="arrow-icon" :class="{'arrow-up': userbtnshow}">&#9662;</i>
                            </div>
                            <div class="btn_box" v-if="userbtnshow">
                                <div class="btnitem" @click="openEditProfile">
                                    <span class="btn-icon">&#9998;</span> 修改资料
                                </div>
                                <div class="btnitem" @click="openPassPage">
                                    <span class="btn-icon">&#128274;</span> 修改密码
                                </div>
                                <div class="btnitem btnitem-danger" @click="logout">
                                    <span class="btn-icon">&#10140;</span> 注销
                                </div>
                            </div>
                    </div>
                </div>
             </div>
        </div>
        <div class="pagebbox">
            <div class="left">
                <el-menu class="menubox"
                        :default-active="$route.path"
                        background-color="transparent"
                        text-color="rgba(255,255,255,0.65)"
                        active-bg-color="rgba(255,255,255,0.08)"
                        active-text-color="#fff"
                        @select="selectItem">
                            <el-sub-menu index="1">
                                <template #title>
                                <span class="menu-icon">&#127968;</span>
                                <span>首页</span>
                                </template>
                                <el-menu-item index="/home/homeinfo">酒店状态</el-menu-item>
                            </el-sub-menu>
                            <el-sub-menu v-for="(item,index) in menulist" :key="index" :index="item.catoryId+1">
                                <template #title>
                                <span class="menu-icon">&#128194;</span>
                                <span>{{item.categoryName}}</span>
                                </template>
                                <el-menu-item v-for="childlist in item.menuList" :index="`/home/`+childlist.pagePath">{{ childlist.menuName }}</el-menu-item>
                            </el-sub-menu>
            
                </el-menu>
            </div>
            <div class="right">
                <div class="page_conttent">
                        <router-view></router-view>
                </div>
                
            </div>
        </div>
    </div>
    <!-- 新订单通知容器 -->
    <div class="order-toast-container">
        <transition-group name="toast-slide">
            <div class="order-toast-item" v-for="toast in orderToasts" :key="toast.id">
                <div class="toast-icon">&#128276;</div>
                <div class="toast-body">
                    <div class="toast-title">新订单通知</div>
                    <div class="toast-desc">您有新的订单，请及时处理</div>
                    <a href="javascript:void(0)" class="toast-link" @click="goOrderManager">前往订单管理 &raquo;</a>
                </div>
                <a href="javascript:void(0)" class="toast-close" @click="removeToast(toast.id)">&times;</a>
            </div>
        </transition-group>
    </div>
     <UpdatePassword v-if="updatepassPageShow" :is-first-login="isFirstLogin" @close="closepassword"></UpdatePassword>
     <!-- 修改资料弹窗 -->
     <div class="edit-profile-mask" v-if="editProfileShow" @click.self="closeEditProfile">
         <div class="edit-profile-box">
             <div class="edit-profile-header">
                 <h3>修改资料</h3>
                 <a href="javascript:void(0)" @click="closeEditProfile" class="close-btn">&times;</a>
             </div>
             <div class="edit-profile-content">
                 <div class="ep-item ep-img-item">
                     <label>用户头像</label>
                     <div class="ep-picbox">
                         <div class="ep-avatar" @click="triggerAvatarUpload">
                             <img :src="editForm.storeImg || defaultAvatar">
                         </div>
                         <div class="ep-pic-tip">点击头像上传<br/>支持裁剪</div>
                         <div class="ep-piccut-hide">
                             <PicCut v-model="editForm.cutpic" :inputid="'ep_avatar'"/>
                         </div>
                     </div>
                 </div>
                 <div class="ep-item">
                     <label>用户昵称</label>
                     <input type="text" v-model="editForm.storeUserName" placeholder="请输入用户昵称"/>
                 </div>
                 <div class="ep-btns">
                     <a href="javascript:void(0)" class="ep-cancel" @click="closeEditProfile">取消</a>
                     <a href="javascript:void(0)" class="ep-submit" @click="handleEditProfile">保存</a>
                 </div>
             </div>
         </div>
     </div>
</template>
<script>
import Storage from '../../tools/Storage'
import UpdatePassword from './UpdatePassword.vue';
import {selectNavList,getUserInfo,updateUserInfo} from '@/tools/Api'
import { ElMessage } from 'element-plus';
import PicCut from '@/pages/common/PicCut.vue'
import { connectWebSocket, disconnectWebSocket } from '@/tools/Websocket'
export default {
    name:"Home",
    data(){
        return{
           menulist:[],
           userImg:require("@/assets/touxiang.png"),
           defaultAvatar:require("@/assets/touxiang.png"),
           usershowname:"admin",
           userbtnshow:false,
           updatepassPageShow:false,
           editProfileShow:false,
           editForm:{
               storeUserName:"",
               storeImg:"",
               cutpic:""
           },
           storeId:"",
           isFirstLogin:false,
           orderAudio:null,
           orderToasts:[],
           toastIdCounter:0
        }
    },
    components:{
        UpdatePassword,
        PicCut
    },
    watch:{
        'editForm.cutpic':{
            handler(newVal){
                if(newVal && newVal.fileFullPath){
                    this.editForm.storeImg=newVal.fileFullPath
                }
            },
            deep:true
        }
    },
    methods: {
        playOrderAudio(){
            if(this.orderAudio){
                this.orderAudio.currentTime=0
                this.orderAudio.play().catch(err=>{
                    console.warn('语音播放失败:',err)
                })
            }
        },
        onNewOrder(messageBody){
            console.log('收到新订单:',messageBody)
            this.playOrderAudio()
            this.addToast()
        },
        addToast(){
            const id=++this.toastIdCounter
            this.orderToasts.push({id:id})
            // 8秒后自动移除
            setTimeout(()=>{
                this.removeToast(id)
            },8000)
        },
        removeToast(id){
            const idx=this.orderToasts.findIndex(t=>t.id===id)
            if(idx>-1){
                this.orderToasts.splice(idx,1)
            }
        },
        goOrderManager(){
            this.$router.push({name:'ordermanager'})
        },
        initWebSocket(storeId){
            const topic=`/user/${storeId}/topic/new-orders`
            connectWebSocket(topic, this.onNewOrder)
        },
        getUserInfoData(){
            getUserInfo().then(res=>{
                if(res.status==0){
                    const data=res.data
                    if(data.storeUserName){
                        this.usershowname=data.storeUserName
                    }
                    if(data.storeImg){
                        this.userImg=data.storeImg
                    }
                    this.editForm.storeUserName=data.storeUserName||""
                    this.editForm.storeImg=data.storeImg||""
                    // 获取storeId后初始化WebSocket
                    if(data.storeId && !this.storeId){
                        this.storeId=data.storeId
                        this.initWebSocket(this.storeId)
                    }
                    // 第一次登录强制修改密码
                    if(data.storeLoginCount==1){
                        this.isFirstLogin=true
                        this.updatepassPageShow=true
                    }
                }
            }).catch(error=>{
                console.log(error)
            })
        },
        openEditProfile(){
            this.userbtnshow=false
            this.editProfileShow=true
            this.getUserInfoData()
        },
        triggerAvatarUpload(){
            const input=document.getElementById('ep_avatar')
            if(input){
                input.click()
            }
        },
        closeEditProfile(){
            this.editProfileShow=false
        },
        handleEditProfile(){
            if(!this.editForm.storeUserName || this.editForm.storeUserName.trim().length<1){
                ElMessage({message:'用户昵称不能为空',type:'error',duration:1500})
                return
            }
            const params={
                storeUserName:this.editForm.storeUserName,
                storeImg:this.editForm.storeImg||""
            }
            updateUserInfo(params).then(res=>{
                if(res.status==0){
                    ElMessage({message:'修改成功',type:'success',duration:1500})
                    this.usershowname=this.editForm.storeUserName
                    this.userImg=this.editForm.storeImg||this.defaultAvatar
                    this.closeEditProfile()
                }else{
                    ElMessage({message:res.msg||'修改失败',type:'error',duration:1500})
                }
            }).catch(error=>{
                console.log(error)
                ElMessage({message:'请求失败',type:'error',duration:1500})
            })
        },
        logout() {
            Storage.commit('clearUserInfo');
            
            sessionStorage.setItem("menuList","")
            this.$router.push({name:'login'})
        },
        selectItem(index) {
            this.$router.push(index)
        },
        getNav(){
            selectNavList().then(res=>{
                                    if(res.status==0){
                                        const menuList=JSON.stringify(res.data.list)
                                         sessionStorage.setItem("menuList",menuList)
                                        
                                    }
                                
                                }).catch(error=>{
                                    ElMessage({
                                        message:'请求失败！', 
                                        type:'error', 
                                        duration:1500
                                    })

                                })
            this.menulist=JSON.parse(sessionStorage.getItem("menuList"));
        },
        userbtnclick(){
            this.userbtnshow=!this.userbtnshow
            if(this.userbtnshow){
                window.addEventListener('click', this.hideuserbtnbox)
            }else{
                 window.removeEventListener('click', this.hideuserbtnbox)  
            }
        },
        hideuserbtnbox(e){
                let s1=this.$refs.userbtn
                if((s1!==null||s1!=undefined)&&!s1.contains(e.target)){
                    this.userbtnshow=false
                    window.removeEventListener('click', this.hideuserbtnbox)  
                }

        } ,
       closepassword(){
             this.updatepassPageShow=false
       },
       openPassPage(){
           this.updatepassPageShow=true
       }
        
    },
    mounted(){
        this.getNav()
        this.getUserInfoData()
        // 初始化订单语音提示
        this.orderAudio=new Audio(require('@/assets/new-order.wav'))
        this.orderAudio.volume=1.0
    },
    beforeDestroy(){
        disconnectWebSocket()
        if(this.orderAudio){
            this.orderAudio=null
        }
    }
}
</script>
<style scoped>
/* ===== 整体布局 ===== */
#container {
    height: 100%;
    width: 100%;
    position: relative;
    background-color: #f5f6f8;
    float: left;
    min-width: 1400px;
    overflow: hidden;
}

/* ===== 顶部 Header ===== */
#container .header {
    width: 100%;
    height: 64px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%);
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.15);
    position: relative;
    z-index: 100;
}
#container .header .logo {
    width: 220px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-right: 1px solid rgba(255,255,255,0.08);
    padding-right: 20px;
}
#container .header .logo img {
    height: 100%;
    width: auto !important;
    margin: 0 !important;
}
.header-center {
    flex: 1;
    padding: 0 30px;
}
.welcome-title {
    margin: 0;
    font-size: 17px;
    font-weight: 500;
    color: rgba(255,255,255,0.85);
    letter-spacing: 1px;
}
.header-right {
    flex-shrink: 0;
    display: flex;
    align-items: center;
}

/* 用户信息区 */
#container .header .userbox {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
}
#container .header .userbox .userimg {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid rgba(255,255,255,0.2);
    flex-shrink: 0;
}
#container .header .userbox .userimg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
#container .header .userbox .userbtn {
    position: relative;
}
#container .header .userbox .userbtn .username {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
}
#container .header .userbox .userbtn .username:hover {
    background: rgba(255,255,255,0.1);
}
.uname {
    font-size: 14px;
    color: rgba(255,255,255,0.9);
    font-weight: 500;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.arrow-icon {
    font-size: 10px;
    color: rgba(255,255,255,0.5);
    transition: transform 0.25s;
    font-style: normal;
}
.arrow-icon.arrow-up {
    transform: rotate(180deg);
}

/* 用户下拉菜单 */
#container .header .userbox .userbtn .btn_box {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 160px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.15);
    overflow: hidden;
    z-index: 50;
    padding: 6px 0;
    animation: dropIn 0.2s ease;
}
@keyframes dropIn {
    from { opacity: 0; transform: translateY(-6px); }
    to { opacity: 1; transform: translateY(0); }
}
#container .header .userbox .userbtn .btn_box .btnitem {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    font-size: 14px;
    color: #444;
    cursor: pointer;
    transition: all 0.2s;
}
#container .header .userbox .userbtn .btn_box .btnitem:hover {
    background: #f5f6f8;
    color: #1a1a2e;
}
#container .header .userbox .userbtn .btn_box .btnitem .btn-icon {
    font-size: 14px;
    width: 18px;
    text-align: center;
}
#container .header .userbox .userbtn .btn_box .btnitem-danger {
    color: #d9534f;
}
#container .header .userbox .userbtn .btn_box .btnitem-danger:hover {
    background: #fef0f0;
    color: #d9534f;
}

/* ===== 主体区域 ===== */
#container .pagebbox {
    width: 100%;
    height: calc(100% - 64px);
    display: flex;
}

/* 侧边栏 */
#container .pagebbox .left {
    width: 240px;
    height: 100%;
    background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
    overflow-y: auto;
    overflow-x: hidden;
    flex-shrink: 0;
}
#container .pagebbox .left::-webkit-scrollbar {
    width: 4px;
}
#container .pagebbox .left::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.15);
    border-radius: 2px;
}
.sidebar-header {
    padding: 20px 20px 10px;
}
.sidebar-label {
    font-size: 11px;
    color: rgba(255,255,255,0.3);
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 600;
}
.menu-icon {
    font-size: 16px;
    margin-right: 8px;
}

/* 菜单深度样式 */
::v-deep .el-menu {
    background-color: transparent !important;
    border-right: none !important;
    padding: 0 8px;
}
::v-deep .el-sub-menu__title {
    height: 44px;
    line-height: 44px;
    border-radius: 8px !important;
    margin-bottom: 2px;
    font-size: 14px;
    color: rgba(255,255,255,0.65) !important;
    transition: all 0.2s;
}
::v-deep .el-sub-menu__title:hover {
    background-color: rgba(255,255,255,0.06) !important;
    color: rgba(255,255,255,0.9) !important;
}
::v-deep .el-sub-menu__title i,
::v-deep .el-sub-menu__title .el-sub-menu__icon-arrow {
    color: rgba(255,255,255,0.4) !important;
}
::v-deep .el-menu-item {
    height: 40px;
    line-height: 40px;
    border-radius: 8px !important;
    margin: 2px 0;
    font-size: 13px;
    color: rgba(255,255,255,0.55) !important;
    transition: all 0.2s;
}
::v-deep .el-menu-item:hover {
    background-color: rgba(255,255,255,0.06) !important;
    color: rgba(255,255,255,0.9) !important;
}
::v-deep .el-menu-item.is-active {
    background: linear-gradient(135deg, rgba(18,171,4,0.2), rgba(18,171,4,0.1)) !important;
    color: #4caf50 !important;
    font-weight: 600;
    position: relative;
}
::v-deep .el-menu-item.is-active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    background: #4caf50;
    border-radius: 0 3px 3px 0;
}

/* 右侧内容区 */
#container .pagebbox .right {
    flex: 1;
    overflow: hidden;
    position: relative;
    background: #f5f6f8;
}
#container .pagebbox .right .page_conttent {
    width: 100%;
    height: 100%;
    position: relative;
}

/* ===== 修改资料弹窗 ===== */
.edit-profile-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    background-color: rgba(0,0,0,0.45);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
}
.edit-profile-box {
    width: 460px;
    background-color: #fff;
    border-radius: 14px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.18);
    animation: modalIn 0.25s ease;
    overflow: hidden;
}
@keyframes modalIn {
    from { opacity: 0; transform: scale(0.95) translateY(10px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
}
.edit-profile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    border-bottom: 1px solid #f0f0f0;
}
.edit-profile-header h3 {
    margin: 0;
    font-size: 17px;
    color: #1a1a2e;
    font-weight: 600;
}
.edit-profile-header .close-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #999;
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.2s;
}
.edit-profile-header .close-btn:hover {
    background: #f5f5f5;
    color: #333;
}
.edit-profile-content {
    padding: 24px;
}
.ep-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
}
.ep-item:last-child {
    margin-bottom: 0;
}
.ep-item label {
    width: 80px;
    flex-shrink: 0;
    font-size: 14px;
    color: #555;
    font-weight: 500;
    line-height: 42px;
    text-align: right;
    padding-right: 12px;
}
.ep-item input {
    flex: 1;
    height: 42px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    outline: none;
    font-size: 14px;
    padding: 0 14px;
    box-sizing: border-box;
    color: #333;
    transition: border-color 0.2s, box-shadow 0.2s;
}
.ep-item input:focus {
    border-color: #12ab04d4;
    box-shadow: 0 0 0 3px rgba(18,171,4,0.1);
}
.ep-item input::placeholder {
    color: #bbb;
}
.ep-item.ep-img-item {
    align-items: flex-start;
}
.ep-item .ep-picbox {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 14px;
}
.ep-item .ep-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #e8e8e8;
    cursor: pointer;
    transition: border-color 0.2s;
    flex-shrink: 0;
}
.ep-item .ep-avatar:hover {
    border-color: #12ab04d4;
}
.ep-item .ep-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.ep-item .ep-pic-tip {
    font-size: 12px;
    color: #bbb;
    line-height: 1.6;
}
.ep-item .ep-piccut-hide {
    width: 0;
    height: 0;
    overflow: hidden;
}
.ep-btns {
    display: flex;
    justify-content: center;
    gap: 16px;
    padding-top: 10px;
}
.ep-btns a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 110px;
    height: 40px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s;
}
.ep-cancel {
    background: #fff;
    color: #666;
    border: 1px solid #dcdfe6;
}
.ep-cancel:hover {
    color: #333;
    border-color: #c0c4cc;
    background: #f5f5f5;
}
.ep-submit {
    background: linear-gradient(135deg, #12ab04d4, #0d8a03);
    color: #fff;
    border: none;
    box-shadow: 0 4px 12px rgba(18,171,4,0.25);
}
.ep-submit:hover {
    box-shadow: 0 6px 16px rgba(18,171,4,0.35);
    transform: translateY(-1px);
}

/* ===== 新订单通知 Toast ===== */
.order-toast-container {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 9999;
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    pointer-events: none;
}
.order-toast-item {
    width: 320px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 6px 24px rgba(0,0,0,0.12);
    display: flex;
    align-items: flex-start;
    padding: 16px;
    gap: 12px;
    pointer-events: auto;
    border-left: 4px solid #e57834;
    animation: toastFadeIn 0.3s ease;
}
@keyframes toastFadeIn {
    from { opacity: 0; transform: translateX(30px); }
    to { opacity: 1; transform: translateX(0); }
}
.order-toast-item .toast-icon {
    font-size: 24px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #fff3e0, #ffe0b2);
    border-radius: 10px;
    flex-shrink: 0;
}
.order-toast-item .toast-body {
    flex: 1;
    min-width: 0;
}
.order-toast-item .toast-title {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 4px;
}
.order-toast-item .toast-desc {
    font-size: 13px;
    color: #888;
    margin-bottom: 8px;
}
.order-toast-item .toast-link {
    font-size: 13px;
    color: #12ab04d4;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s;
}
.order-toast-item .toast-link:hover {
    color: #0d8a03;
}
.order-toast-item .toast-close {
    font-size: 18px;
    color: #ccc;
    text-decoration: none;
    line-height: 1;
    flex-shrink: 0;
    transition: color 0.2s;
}
.order-toast-item .toast-close:hover {
    color: #999;
}
/* 过渡动画 */
.toast-slide-enter-active {
    transition: all 0.3s ease;
}
.toast-slide-leave-active {
    transition: all 0.3s ease;
}
.toast-slide-enter-from {
    opacity: 0;
    transform: translateX(40px);
}
.toast-slide-leave-to {
    opacity: 0;
    transform: translateX(40px);
}
</style>

